import { useEffect, useState, useContext } from 'react';
import { AppContext } from '../App';
import { callApi, callGameServerApi, getInlineLoader, trimString } from '../Helpers';
import { AiOutlineUser, AiFillStar } from 'react-icons/ai';
import { IoPersonAddSharp } from 'react-icons/io5';

export default function OneUser(props) {
  const appContext = useContext(AppContext);
  const [ simple, setSimple ] = useState(props.simple);
  const [ id, setId ] = useState(props.id);
  const [ username, setUsername ] = useState('');
  const [ injectedView, setInjectedView ] = useState(props.injectedView);
  const [ userData, setUserData ] = useState(null);
  const [ loading, setLoading ] = useState(false);
  const [ isFriend, setIsFriend ] = useState(false);
  const [ hasRequestedFriendship, setHasRequestedFriendship ] = useState(false);
  const [ isFriendRequestSent, setIsFriendRequestSent ] = useState(false);

  const getUserData = async () => {
    setLoading(true);
    await callGameServerApi('get-user-public-data', { id }).then((response) => {
      setLoading(false);
      if(response.status === 1) {
        setUserData(response.userData);
      }
    })
  }

  function isFriendChecker() {
    if(appContext.userData && userData) {
      JSON.parse(appContext.userData.friends).forEach((item, i) => {
        if(Number(item.id) === Number(userData.id)) {
          setIsFriend(true);
        }
      });
    } else {
      setIsFriend(false);
    }
  }

  function isFriendRequestSentChecker() {
    
    if(appContext.userData && userData) {
      JSON.parse(userData.friendRequests).forEach((item, i) => {
        if(Number(item.id) === Number(appContext.userData.id)) {
          setIsFriendRequestSent(true);
        }
      });
    } else {
      setIsFriendRequestSent(false);
    }
  }

  function hasRequestedFriendshipChecker() {
    if(appContext.userData && userData) {
      JSON.parse(appContext.userData.friendRequests).forEach((item, i) => {
        if(Number(item.id) === Number(userData.id)) {
          setHasRequestedFriendship(true);
        }
      });
    } else {
      setHasRequestedFriendship(false);
    }
  }

  const viewUser = () => {
    // TODO: Implement user profile view here
    appContext.navTo({
      item: 'view',
      subItem: 'browse_profile',
      extraItem: id,
    });
  }

  const sendFriendRequest = async () => {
    //send friend request
    setLoading(true);
    await callGameServerApi("send-friend-request", { requestedUserId: id, }).then((response) => {
      if(response.status === 1) {
        appContext.tellMessage(`Friend request to ${username}  was sent successfully`)
        appContext.getUserData();
        getUserData();
        if(props.refresher) {
          props.refresher();
        }
      } else {
        appContext.tellError(response.msg);
      }
    })
    setLoading(false);
  }

  const acceptFriendRequest = async () => {
    //send friend request
    setLoading(true);
    await callGameServerApi("accept-friend-request", { requesterUserId: id, }).then((response) => {
      if(response.status === 1) {
        appContext.tellMessage(`${username} is now your friend`);
        appContext.getUserData();
        getUserData();
        if(props.refresher) {
          props.refresher();
        }
      } else {
        appContext.tellError(response.msg);
      }
    })
    setLoading(false);
  }

  const init = async () => {
    await getUserData();
  }

  useEffect(() => {
    setId(props.id);
    setInjectedView(props.injectedView);
  }, [ props.id, props.injectedView ]);

  useEffect(() => {
    init();
  }, [ id, injectedView ]);

  useEffect(() => {
    if(userData) {
      setUsername(userData.username);
    }

    isFriendChecker();
    hasRequestedFriendshipChecker();
    isFriendRequestSentChecker();
  }, [ appContext.userData, userData, ])

  useEffect(() => {
    //..
  }, [ isFriend, hasRequestedFriendship, isFriendRequestSent ])

  if(simple) {
    return (
      <span
        onClick={viewUser}
        className="font-bold mOneLineText z-depth-1"
        style={{
          cursor: "pointer",
          width: "auto",
          height: "auto",
          background: "var(--faintBlack)",
          padding: "5px",
          fontSize: "14px",
          lineHeight: "30px",
          borderRadius: "10px"
        }}
      >
        <span className="text-light" style={{ textTransform: "capitalize" }}>{trimString(username)}</span>&nbsp;
        {
          (userData && !loading) ?
          <>
            <span className="font-regular text-bluish"> - {userData.points} Points</span>
          </>:""
        }
      </span>
    )
  } else {
    return (
      <div
        style={{
          width: "100%",
          padding: "10px",
          marginTop: "15px"
        }}
        className="z-depth-1"
      >
        <div className="d-flex">
          <AiOutlineUser size={40} style={{ flexShrink: "0", cursor: 'pointer' }} onClick={viewUser}/>
          <div className="flex-grow-1" style={{ paddingLeft: "10px" }}>
            <h6 onClick={viewUser} style={{ cursor: 'pointer' }} className="text-bluish font-bold">{username}</h6>
            <div className="text-start support-loading">
            {
              (loading || !userData) ?
              getInlineLoader('small'):
              <>
                <h5 className="text-muted" style={{ fontSize: "12px" }}>Points: {userData.points}</h5>
                <div className="text-light d-flex">
                  <AiFillStar size={30} color="var(--goldish)" className="align-self-center"/>
                  <span className="align-self-center" style={{ fontSize: "20px", marginLeft: "5px" }}>{JSON.parse(userData.stars).length}</span>
                </div>

                <div className='text-end'>
                  {
                    (isFriend) ?
                    <h6 style={{ fontSize: "12px" }} className='text-goldish'>
                        Friends
                    </h6>
                    :
                    (hasRequestedFriendship) ?
                    <button
                      className='btn btn-sm bg-goldish'
                      onClick={acceptFriendRequest}
                    >
                      Accept Friend Request&nbsp;<IoPersonAddSharp size={20}/>
                    </button>
                    :
                    (isFriendRequestSent) ?
                    <h6 style={{ fontSize: "12px" }} className='text-redish'>
                        Friend Request sent
                    </h6>
                    :
                    (appContext.userData && Number(appContext.userData.id) !== Number(id)) ?
                    <button
                      className='btn btn-sm bg-bluish'
                      onClick={sendFriendRequest}
                    >
                      Send Friend Request&nbsp;<IoPersonAddSharp size={20}/>
                    </button>
                    : ""
                  }

                 
                </div>
              </>
            }
            </div>
          </div>
        </div>
        
        {(injectedView) ? injectedView : ""}
      </div>
    )
  }

}
